import {Helpers} from '@selpia/shared/utils';
import {Dimension, DimensionLevel} from '@selpia/shared/models';

export class DimensionHelper {
  static getMatchingLevel(dimension: Dimension, levelNumber = 1): DimensionLevel {
    const topLevel = dimension.levels.find((level) => level.levelNumber === levelNumber);
    if (!topLevel) {
      throw new Error(`Failed to find top Level for Dimension: ${dimension.name}`);
    }
    return topLevel;
  }

  static getDimensionOf(dimensionLevel: DimensionLevel | undefined, allDimensions: Dimension[]): Dimension {
    if (!dimensionLevel) {
      throw new Error('No dimensionLevel passed');
    }

    const matchingDimension = allDimensions?.find((dimension) =>
      dimension.levels.some((level) => level === dimensionLevel),
    );

    if (!matchingDimension) {
      throw new Error(`Failed to find matching Dimension for DimensionLevel: ${dimensionLevel.name}`);
    }
    return matchingDimension;
  }

  static enrichWithCode(dimensions: Dimension[]): Dimension[] {
    return dimensions.map(dimension => ({
      ...dimension,
      code: dimension.name.substring(0, 1) + Helpers.toBase36(Helpers.sumCharacterCodesWithIndex(dimension.name)),
    }));
  }
}
